export default __webpack_public_path__ + "static/melvito-c595e44fcbc9e0f0a83dbe88a274fd36.png";